import { Pagination as MantinePagination, Center, type PaginationProps, useMantineTheme } from '@mantine/core';

const Pagination: React.FC<PaginationProps> = (props: PaginationProps) => {
  const { colors } = useMantineTheme();
  if ((props.total ?? 0) < 1) {
    return <></>;
  }
  return (
    <Center
      style={{ borderTop: `1px solid ${colors.gray[4]}` }}
    >
      <MantinePagination
        withEdges
        my={16}
        {...props}
      />
    </Center>
  );
};

export default Pagination;
